export class ElementRiskAssessment {
  public constructor(
    public id: string,
    public name: string,
    public webUrl: URL,
    public conclusion: string,
    public material: string
  ) {}
}
